module.exports = __webpack_public_path__ + "img/badge_mba.2c54bda2.jpg";